
export const COUNTRIES = [
  { value: 'United States', label: 'United States' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Mexico', label: 'Mexico' },
  { value: 'United Kingdom', label: 'United Kingdom' },
  { value: 'Ireland', label: 'Ireland' },
  { value: 'France', label: 'France' },
  { value: 'Germany', label: 'Germany' },
  { value: 'Spain', label: 'Spain' },
  { value: 'Italy', label: 'Italy' },
  { value: 'Netherlands', label: 'Netherlands' },
  { value: 'Belgium', label: 'Belgium' },
  { value: 'Switzerland', label: 'Switzerland' },
  { value: 'Sweden', label: 'Sweden' },
  { value: 'Norway', label: 'Norway' },
  { value: 'Denmark', label: 'Denmark' },
  { value: 'Poland', label: 'Poland' },
  { value: 'Portugal', label: 'Portugal' },
  { value: 'Australia', label: 'Australia' },
  { value: 'New Zealand', label: 'New Zealand' },
  { value: 'Japan', label: 'Japan' },
  { value: 'China', label: 'China' },
  { value: 'India', label: 'India' },
  { value: 'Singapore', label: 'Singapore' },
  { value: 'United Arab Emirates', label: 'United Arab Emirates' },
  { value: 'Saudi Arabia', label: 'Saudi Arabia' },
  { value: 'South Africa', label: 'South Africa' },
  { value: 'Brazil', label: 'Brazil' },
  { value: 'Argentina', label: 'Argentina' },
  { value: 'Chile', label: 'Chile' },
  { value: 'Pakistan', label: 'Pakistan' },
]

// Countries where the state/province field should render as a dropdown
// of known states instead of a free-text input.
export const US_STATES = [
  { value: 'Alabama', label: 'Alabama' }, { value: 'Alaska', label: 'Alaska' },
  { value: 'Arizona', label: 'Arizona' }, { value: 'Arkansas', label: 'Arkansas' },
  { value: 'California', label: 'California' }, { value: 'Colorado', label: 'Colorado' },
  { value: 'Connecticut', label: 'Connecticut' }, { value: 'Delaware', label: 'Delaware' },
  { value: 'Florida', label: 'Florida' }, { value: 'Georgia', label: 'Georgia' },
  { value: 'Hawaii', label: 'Hawaii' }, { value: 'Idaho', label: 'Idaho' },
  { value: 'Illinois', label: 'Illinois' }, { value: 'Indiana', label: 'Indiana' },
  { value: 'Iowa', label: 'Iowa' }, { value: 'Kansas', label: 'Kansas' },
  { value: 'Kentucky', label: 'Kentucky' }, { value: 'Louisiana', label: 'Louisiana' },
  { value: 'Maine', label: 'Maine' }, { value: 'Maryland', label: 'Maryland' },
  { value: 'Massachusetts', label: 'Massachusetts' }, { value: 'Michigan', label: 'Michigan' },
  { value: 'Minnesota', label: 'Minnesota' }, { value: 'Mississippi', label: 'Mississippi' },
  { value: 'Missouri', label: 'Missouri' }, { value: 'Montana', label: 'Montana' },
  { value: 'Nebraska', label: 'Nebraska' }, { value: 'Nevada', label: 'Nevada' },
  { value: 'New Hampshire', label: 'New Hampshire' }, { value: 'New Jersey', label: 'New Jersey' },
  { value: 'New Mexico', label: 'New Mexico' }, { value: 'New York', label: 'New York' },
  { value: 'North Carolina', label: 'North Carolina' }, { value: 'North Dakota', label: 'North Dakota' },
  { value: 'Ohio', label: 'Ohio' }, { value: 'Oklahoma', label: 'Oklahoma' },
  { value: 'Oregon', label: 'Oregon' }, { value: 'Pennsylvania', label: 'Pennsylvania' },
  { value: 'Rhode Island', label: 'Rhode Island' }, { value: 'South Carolina', label: 'South Carolina' },
  { value: 'South Dakota', label: 'South Dakota' }, { value: 'Tennessee', label: 'Tennessee' },
  { value: 'Texas', label: 'Texas' }, { value: 'Utah', label: 'Utah' },
  { value: 'Vermont', label: 'Vermont' }, { value: 'Virginia', label: 'Virginia' },
  { value: 'Washington', label: 'Washington' }, { value: 'West Virginia', label: 'West Virginia' },
  { value: 'Wisconsin', label: 'Wisconsin' }, { value: 'Wyoming', label: 'Wyoming' },
  { value: 'District of Columbia', label: 'District of Columbia' },
]

export const CANADA_PROVINCES = [
  { value: 'Alberta', label: 'Alberta' },
  { value: 'British Columbia', label: 'British Columbia' },
  { value: 'Manitoba', label: 'Manitoba' },
  { value: 'New Brunswick', label: 'New Brunswick' },
  { value: 'Newfoundland and Labrador', label: 'Newfoundland and Labrador' },
  { value: 'Nova Scotia', label: 'Nova Scotia' },
  { value: 'Northwest Territories', label: 'Northwest Territories' },
  { value: 'Nunavut', label: 'Nunavut' },
  { value: 'Ontario', label: 'Ontario' },
  { value: 'Prince Edward Island', label: 'Prince Edward Island' },
  { value: 'Quebec', label: 'Quebec' },
  { value: 'Saskatchewan', label: 'Saskatchewan' },
  { value: 'Yukon', label: 'Yukon' },
]

export const STATES_BY_COUNTRY = {
  'United States': US_STATES,
  Canada: CANADA_PROVINCES,
}